import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import useAuth from "./useAuth";
import useSavePhoenixClickMutation from "../react-query/mutations/use-save-phoenix-click";
import {
  capturePhoenixClickId,
  getPhoenixClickIdFromUrl,
} from "../utils/phoenix-click";

export default function usePhoenixClickAttribution() {
  const { search } = useLocation();
  const { isLoggedIn } = useAuth();
  const { mutate } = useSavePhoenixClickMutation();

  useEffect(() => {
    capturePhoenixClickId();
  }, [search]);

  useEffect(() => {
    if (!isLoggedIn) return;

    const phxClickId = getPhoenixClickIdFromUrl();
    if (!phxClickId) return;

    mutate(phxClickId);
  }, [isLoggedIn, search, mutate]);
}
